import React, { useState, lazy, Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./pages/Pricing/Pricing.css";

import AuthService from "./services/auth.service";
import PrivateRoutes from "./services/PrivateRoutes";
import { UserContext } from "./services/useContext";
import Logs from"./pages/Logs/Logs"
import Profile from"./pages/Profile/Profile"
import Home from"./components/Home"
import Login from"./components/Login"
import PricingTable from"./pages/PricingTable"
import Masters  from "./pages/Master/Masters"
import PricingChart  from "./pages/PricingChart/PricingChart"
import Pricing from "./pages/Pricing/Pricing"
import Adduser from "pages/Adduser";
import IpAdressList from "pages/IpAddress";
import ImageServer from "./pages/ImageSever/Sidebar";
import Jewellery from "pages/jewellery/Jewellery";
import ProfileDetails from "pages/Profile/ProfileDetails";
import AutomationPage from "pages/automation";


const App = () => {
  const [state, setState] = useState({});
  const stateHandle = (obj) => {
    setState({ ...state, ...obj });
  };
  return (
    <div>
      <UserContext.Provider
        value={{ ...AuthService.getCurrentUser(), state, stateHandle }}
      >
        {/* <Suspense fallback={<div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }} boundary={<ErrorFallback />} ><Loading /></div>}> */}
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<PrivateRoutes />}>
              <Route path="/" element={<Home />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profileDetails" element={<ProfileDetails />} />
              <Route path="/Logs" element={<Logs />} />
              <Route path="/PricingTable" element={<PricingTable />} />
              <Route path="/Pricing/:pricingNo" element={<Pricing />} />
              <Route path="/Pricing" element={<Pricing />} />
              <Route path="/Masters" element={<Masters />} />
              <Route path="/PricingChart" element={<PricingChart />} />
              <Route path="/IpAddress" element={<IpAdressList />} />
              <Route path="/Images" element={<ImageServer />} />
              <Route path="/designExtractor" element={<Jewellery />} />
              <Route path="/cron-list" element={<AutomationPage />} />

              
             
              {/* <Route path="/translate" element={<Translate />} /> */}
              {/* <Route path="/Dummy" element={<Adduser />} /> */}
            </Route>
          </Routes>
        {/* </Suspense> */}
      </UserContext.Provider>
    </div>
  );
};
export default App;


const ErrorFallback = () => (
  <div className="error-container">
    <h3>Something went wrong while loading this component.</h3>
    <p>Please try again later.</p>
  </div>
);
